import React, { useCallback, memo, useState, useEffect, useMemo } from 'react';
import BannerCreative from './BannerCreative';
import Card from '../baseUiV3/components/Card';
import { useSelector } from 'react-redux';

const SponsoredCard = ({ type = '', className = '', position = '', page_name = '' }) => {
  const [selectedCampaign, setselectedCampaign] = useState('');
  const showSponsoredCard = useSelector((state) => state.banner.showSponsorBanner);

  useEffect(() => {
    return () => {
      setselectedCampaign('');
    };
  }, []);

  const onCampaignSelect = useCallback(
    (campaign) => {
      setselectedCampaign(campaign);
      console.log('campaign', campaign);
    },
    [selectedCampaign]
  );

  const onVisitBtnClick = useCallback(() => {}, []);
  const showCard = useMemo(() => showSponsoredCard[position], [showSponsoredCard, position]);
  console.log('showSponsoredCard', position, showSponsoredCard, '\n', showSponsoredCard[position]);
  return showSponsoredCard[position] ? (
    // clr_v3_card__sponsor--maxwidth for desktop feed. dashboad and profile
    <Card className={`clr_v3_card__sponsor  ${className ?? ''}`} type={type}>
      <Card.Body>
        <Card.Header>
          <div className="d-flex flex-column bd-highlight mb-3"></div>
          <span className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto">
            <i className="flaticon-ad-sponsor fs-3 me-2 text-primary"></i>
            <span>Sponsor</span>
          </span>
        </Card.Header>
        <div className="d-flex">
          <div className="flex-grow-1 d-flex justify-content-center flex-column">
            {selectedCampaign && selectedCampaign?.CTA_text && (
              <Card.Title>{selectedCampaign?.CTA_text}</Card.Title>
            )}
          </div>
        </div>

        <BannerCreative
          page_id={0}
          position={position}
          page_name={page_name}
          onCampaignSelect={onCampaignSelect}
          onVisitClick={onVisitBtnClick}
        />
      </Card.Body>
    </Card>
  ) : (
    <>{/* <h1>hihih</h1> */}</>
  );
};

export default memo(SponsoredCard);
